/**
 * frontend/src/components/setup/EmailConfigPage.jsx  —  NEW FILE
 * Place in: src/components/setup/
 * Import in SetupPage.jsx (see bottom of this file for instructions)
 */
import { useState, useEffect } from 'react';
import { emailConfigAPI } from '../../api';
import toast from 'react-hot-toast';

const IS = {
  width:'100%', border:'1.5px solid #e2e8f0', borderRadius:8,
  padding:'9px 12px', fontSize:13, outline:'none',
  boxSizing:'border-box', background:'#fff', color:'#1a1f2e',
};
const LS = { fontSize:12, fontWeight:600, color:'#475569', display:'block', marginBottom:4 };
const G2 = { display:'grid', gridTemplateColumns:'1fr 1fr', gap:'14px 20px' };
const SH = {
  fontSize:11, fontWeight:700, color:'rgba(26,31,46,.4)',
  textTransform:'uppercase', letterSpacing:'.07em',
  marginBottom:12, paddingBottom:8,
  borderBottom:'1px solid #f1f5f9',
  display:'flex', alignItems:'center', gap:6,
};

function Field({ label, name, value, onChange, type='text', placeholder='', half=false, required=false }) {
  return (
    <div style={half ? {} : { gridColumn:'1/-1' }}>
      <label style={LS}>{label}{required && <span style={{ color:'#dc2626' }}> *</span>}</label>
      <input type={type} name={name} value={value||''} onChange={onChange}
        placeholder={placeholder} autoComplete="off"
        style={IS}/>
    </div>
  );
}

function Toggle({ label, name, checked, onChange, hint }) {
  return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between',
      padding:'10px 0', borderBottom:'1px solid #f8fafc' }}>
      <div>
        <div style={{ fontSize:13, fontWeight:600, color:'#374151' }}>{label}</div>
        {hint && <div style={{ fontSize:11, color:'#94a3b8', marginTop:2 }}>{hint}</div>}
      </div>
      <label style={{ position:'relative', display:'inline-block', width:44, height:24, cursor:'pointer' }}>
        <input type="checkbox" name={name} checked={!!checked} onChange={onChange}
          style={{ opacity:0, width:0, height:0 }}/>
        <span style={{
          position:'absolute', inset:0, borderRadius:24,
          background: checked ? '#1a56db' : '#e2e8f0',
          transition: '.25s',
        }}>
          <span style={{
            position:'absolute', left: checked ? 22 : 2, top:2,
            width:20, height:20, borderRadius:'50%', background:'#fff',
            boxShadow:'0 1px 3px rgba(0,0,0,.2)', transition:'.25s',
          }}/>
        </span>
      </label>
    </div>
  );
}

const BLANK = {
  smtp_host:'', smtp_port:'587', smtp_user:'', smtp_password:'',
  from_name:'iAssets', from_email:'', use_tls:true, use_ssl:false, is_active:true,
  wa_enabled:false, wa_account_sid:'', wa_auth_token:'', wa_from_number:'',
};

export default function EmailConfigPage() {
  const [form,     setForm]     = useState(BLANK);
  const [loading,  setLoading]  = useState(true);
  const [saving,   setSaving]   = useState(false);
  const [testing,  setTesting]  = useState(false);
  const [testEmail,setTestEmail]= useState('');
  const [tab,      setTab]      = useState('smtp');

  const set  = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));
  const setB = e => setForm(f => ({ ...f, [e.target.name]: e.target.checked }));

  useEffect(() => {
    emailConfigAPI.get()
      .then(r => {
        if (r.data.configured) {
          setForm(prev => ({ ...prev, ...r.data }));
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const save = async () => {
    if (!form.smtp_host || !form.from_email) {
      toast.error('SMTP Host and From Email are required'); return;
    }
    setSaving(true);
    try {
      await emailConfigAPI.save({
        ...form,
        smtp_port: parseInt(form.smtp_port) || 587,
      });
      toast.success('Email configuration saved ✓');
    } catch(e) {
      toast.error(e?.response?.data?.detail || 'Save failed');
    } finally { setSaving(false); }
  };

  const testConn = async () => {
    if (!testEmail) { toast.error('Enter a test email address'); return; }
    setTesting(true);
    try {
      const r = await emailConfigAPI.test(testEmail);
      toast.success(r.data.message || 'Test email sent!');
    } catch(e) {
      toast.error(e?.response?.data?.detail || 'Test failed — check SMTP settings');
    } finally { setTesting(false); }
  };

  const TABS = [
    { id:'smtp',      label:'📧 SMTP / Email' },
    { id:'whatsapp',  label:'💬 WhatsApp'     },
    { id:'templates', label:'📄 Templates'    },
  ];

  if (loading) return (
    <div style={{ textAlign:'center', padding:40, color:'#94a3b8', fontSize:14 }}>
      Loading configuration…
    </div>
  );

  return (
    <div style={{ maxWidth:720,overflow:'scroll' }}>
      {/* Status banner */}
      <div style={{ background: form.is_active ? '#f0fdf4' : '#fff5f5',
        border:`1px solid ${form.is_active ? '#bbf7d0' : '#fecaca'}`,
        borderRadius:10, padding:'10px 16px', marginBottom:20,
        display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <div style={{ fontSize:13, color: form.is_active ? '#15803d' : '#dc2626', fontWeight:600 }}>
          {form.is_active ? '✅ Email Notifications Active' : '⛔ Email Notifications Disabled'}
        </div>
        <Toggle label="" name="is_active" checked={form.is_active}
          onChange={e => setForm(f => ({ ...f, is_active: e.target.checked }))}/>
      </div>

      {/* Tabs */}
      <div style={{ display:'flex', borderBottom:'2px solid #f1f5f9', marginBottom:24 }}>
        {TABS.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)}
            style={{ padding:'9px 18px', fontSize:13, border:'none', cursor:'pointer',
              background:'none', fontWeight: tab===t.id ? 700 : 400,
              color: tab===t.id ? '#1a56db' : '#64748b',
              borderBottom: tab===t.id ? '2px solid #1a56db' : '2px solid transparent',
              marginBottom:-2 }}>
            {t.label}
          </button>
        ))}
      </div>

      {/* ── SMTP Tab ── */}
      {tab === 'smtp' && (
        <div style={{ display:'flex', flexDirection:'column', gap:24 }}>

          {/* Server settings */}
          <div style={{ background:'#fff', borderRadius:12, border:'1px solid #e2e8f0', padding:20 }}>
            <div style={SH}>📡 Server Settings</div>
            <div style={G2}>
              <Field label="SMTP Host *" name="smtp_host" value={form.smtp_host}
                onChange={set} placeholder="smtp.gmail.com" required/>
              <Field label="Port" name="smtp_port" value={form.smtp_port}
                onChange={set} placeholder="587" half/>
              <Field label="Username (email)" name="smtp_user" value={form.smtp_user}
                onChange={set} placeholder="your@gmail.com" half/>
              <Field label="Password / App Password" name="smtp_password" value={form.smtp_password}
                onChange={set} type="password" placeholder="App password" half/>
            </div>

            <div style={{ marginTop:14 }}>
              <Toggle label="Use TLS (STARTTLS)" name="use_tls" checked={form.use_tls} onChange={setB}
                hint="Recommended for port 587"/>
              <Toggle label="Use SSL" name="use_ssl" checked={form.use_ssl} onChange={setB}
                hint="For port 465 — disable TLS if using SSL"/>
            </div>
          </div>

          {/* From address */}
          <div style={{ background:'#fff', borderRadius:12, border:'1px solid #e2e8f0', padding:20 }}>
            <div style={SH}>✉️ From Address</div>
            <div style={G2}>
              <Field label="From Name" name="from_name" value={form.from_name}
                onChange={set} placeholder="iAssets" half/>
              <Field label="From Email *" name="from_email" value={form.from_email}
                onChange={set} type="email" placeholder="noreply@company.com" half required/>
            </div>
          </div>

          {/* Test connection */}
          <div style={{ background:'#f8fafc', borderRadius:12, border:'1px solid #e2e8f0', padding:20 }}>
            <div style={SH}>🧪 Test Connection</div>
            <div style={{ display:'flex', gap:10, alignItems:'flex-end' }}>
              <div style={{ flex:1 }}>
                <label style={LS}>Send test email to</label>
                <input type="email" value={testEmail} onChange={e=>setTestEmail(e.target.value)}
                  placeholder="your@email.com" style={IS}/>
              </div>
              <button onClick={testConn} disabled={testing}
                style={{ padding:'9px 20px', background: testing ? '#e2e8f0' : '#1a56db',
                  color: testing ? '#94a3b8' : '#fff', border:'none', borderRadius:8,
                  fontSize:13, fontWeight:600, cursor: testing ? 'not-allowed' : 'pointer',
                  whiteSpace:'nowrap' }}>
                {testing ? 'Sending…' : '📨 Send Test'}
              </button>
            </div>
          </div>

          {/* Quick setup hints */}
          <div style={{ background:'#fffbeb', borderRadius:12, border:'1px solid #fde68a', padding:16 }}>
            <div style={{ fontSize:12, fontWeight:700, color:'#92400e', marginBottom:8 }}>
              💡 Common SMTP Settings
            </div>
            <table style={{ fontSize:12, color:'#64748b', borderCollapse:'collapse', width:'100%' }}>
              {[
                ['Gmail',       'smtp.gmail.com',        '587', 'Use App Password (2FA required)'],
                ['Outlook/365', 'smtp.office365.com',    '587', 'Use your Microsoft password'],
                ['Yahoo',       'smtp.mail.yahoo.com',   '587', 'Use App Password'],
                ['Custom SMTP', 'your-smtp-server.com',  '587', 'Ask your IT team'],
              ].map(([p,h,port,note]) => (
                <tr key={p}>
                  <td style={{ padding:'4px 12px 4px 0', fontWeight:600, color:'#374151', width:100 }}>{p}</td>
                  <td style={{ padding:'4px 12px 4px 0', fontFamily:'monospace' }}>{h}</td>
                  <td style={{ padding:'4px 12px 4px 0' }}>:{port}</td>
                  <td style={{ padding:'4px 0', color:'#94a3b8' }}>{note}</td>
                </tr>
              ))}
            </table>
          </div>
        </div>
      )}

      {/* ── WhatsApp Tab ── */}
      {tab === 'whatsapp' && (
        <div style={{ display:'flex', flexDirection:'column', gap:24 }}>
          <div style={{ background:'#fff', borderRadius:12, border:'1px solid #e2e8f0', padding:20 }}>
            <Toggle label="Enable WhatsApp Notifications" name="wa_enabled"
              checked={form.wa_enabled} onChange={setB}
              hint="Requires Twilio account with WhatsApp Business API"/>

            {form.wa_enabled && (
              <div style={{ marginTop:16 }}>
                <div style={G2}>
                  <Field label="Twilio Account SID" name="wa_account_sid" value={form.wa_account_sid}
                    onChange={set} placeholder="ACxxxxxxxxxxxxxxxx" half/>
                  <Field label="Twilio Auth Token" name="wa_auth_token" value={form.wa_auth_token}
                    onChange={set} type="password" placeholder="Auth token" half/>
                  <Field label="WhatsApp From Number" name="wa_from_number" value={form.wa_from_number}
                    onChange={set} placeholder="whatsapp:+14155238886"/>
                </div>
                <div style={{ marginTop:14, background:'#f0f6ff', borderRadius:8,
                  padding:'12px 14px', fontSize:12, color:'#1a56db' }}>
                  📌 Get your credentials at{' '}
                  <a href="https://console.twilio.com" target="_blank" rel="noreferrer"
                    style={{ color:'#1a56db', fontWeight:600 }}>console.twilio.com</a>.
                  The employee's mobile number in the Employee Master must include country code
                  (e.g. <code>+919876543210</code>).
                </div>
              </div>
            )}

            {!form.wa_enabled && (
              <div style={{ marginTop:14, padding:16, background:'#f8fafc',
                borderRadius:8, fontSize:13, color:'#64748b', textAlign:'center' }}>
                Enable WhatsApp above to configure Twilio credentials.
              </div>
            )}
          </div>
        </div>
      )}

      {/* ── Templates Tab ── */}
      {tab === 'templates' && (
        <div style={{ background:'#fff', borderRadius:12, border:'1px solid #e2e8f0', padding:20 }}>
          <div style={SH}>📄 Notification Templates</div>
          <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
            {[
              { icon:'⚡', label:'Breakdown Alert Email',    note:'Sent immediately when a Breakdown WO is created with an assigned employee',   color:'#fee2e2', border:'#fca5a5' },
              { icon:'🔧', label:'PM Reminder Email',        note:'Sent N days before the PM due date (based on Reminder Days field)',           color:'#dbeafe', border:'#93c5fd' },
              { icon:'💬', label:'WhatsApp Message',         note:'Sent alongside email when WhatsApp is enabled and employee has a mobile',     color:'#f0fdf4', border:'#bbf7d0' },
            ].map(t => (
              <div key={t.label} style={{ background:t.color, border:`1px solid ${t.border}`,
                borderRadius:10, padding:'12px 16px', display:'flex', gap:12, alignItems:'flex-start' }}>
                <span style={{ fontSize:20 }}>{t.icon}</span>
                <div>
                  <div style={{ fontSize:13, fontWeight:700, color:'#1a1f2e' }}>{t.label}</div>
                  <div style={{ fontSize:12, color:'#64748b', marginTop:3 }}>{t.note}</div>
                </div>
              </div>
            ))}
            <div style={{ fontSize:12, color:'#94a3b8', padding:'8px 0' }}>
              Template content is managed in the backend.
              Future versions will support custom template editing.
            </div>
          </div>
        </div>
      )}

      {/* Save button */}
      <div style={{ marginTop:24, display:'flex', justifyContent:'flex-end', gap:10 }}>
        <button onClick={save} disabled={saving}
          style={{ padding:'10px 28px', background: saving ? '#93c5fd' : '#1a56db',
            color:'#fff', border:'none', borderRadius:9,
            fontSize:14, fontWeight:700,
            cursor: saving ? 'not-allowed' : 'pointer' }}>
          {saving ? 'Saving…' : '💾 Save Configuration'}
        </button>
      </div>
    </div>
  );
}

/*
─────────────────────────────────────────────────────────────
SETUP INSTRUCTIONS for SetupPage.jsx:
─────────────────────────────────────────────────────────────

1. Import at the top of SetupPage.jsx:
   import EmailConfigPage from './EmailConfigPage';

2. Add to NAV_ITEMS under 'company' or create a new group:
   { key:'email_config', label:'Email & Notifications' }

3. Add to PAGES mapping:
   email_config: <EmailConfigPage />,

─────────────────────────────────────────────────────────────
api/index.js — add this new export:
─────────────────────────────────────────────────────────────

export const emailConfigAPI = {
  get:  ()          => API.get('/email-config'),
  save: (d)         => API.post('/email-config', d),
  test: (toEmail)   => API.post('/email-config/test', { to_email: toEmail }),
};

export const tasksAPI = {
  list:          (params) => API.get('/tasks/', { params }),
  updateStatus:  (id, status) => API.patch(`/tasks/${id}/status`, { status }),
  sendNotification: (id)  => API.post(`/notifications/send/${id}`),
  logs:          ()       => API.get('/notifications/logs'),
};
*/
